// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('data/service/url').name];

module.exports = angular
  .module('bench.data.service.urlParser', deps)

  .factory(
    'urlParser',
    (BenchUrl, MessageParser) =>
      new MessageParser({
        getMessage(str) {
          return BenchUrl.parseText(str);
        },
      }),
  );
